/**
 * Neurotroopics header: hover mega/dropdown en desktop, sombra al scroll.
 * Compatible con <header-menu> / DetailsDisclosure de Dawn.
 */
(function () {
  'use strict';

  const MQ = '(min-width: 990px)';
  /** Delay al salir del menú: da tiempo a entrar al desplegable sin solaparse al abrir otro */
  const CLOSE_DELAY_MS = 120;

  const closeTimers = new WeakMap();

  function isDesktop() {
    return window.matchMedia(MQ).matches;
  }

  function clearMenuCloseTimer(hm) {
    const t = closeTimers.get(hm);
    if (t) clearTimeout(t);
    closeTimers.delete(hm);
  }

  function closeOtherHeaderMenus(exceptHm) {
    const shell = exceptHm.closest('.neurotroopics-shell');
    if (!shell) return;
    shell.querySelectorAll('header-menu').forEach((other) => {
      if (other === exceptHm) return;
      clearMenuCloseTimer(other);
      const d = other.querySelector('details');
      const s = d && d.querySelector('summary');
      if (!d) return;
      d.removeAttribute('open');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function initHoverMenus(scope) {
    const menus = scope.querySelectorAll('header-menu');

    menus.forEach((hm) => {
      if (hm.dataset.neuroHoverInit === '1') return;
      hm.dataset.neuroHoverInit = '1';

      const details = hm.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      const openMenu = () => {
        if (!isDesktop()) return;
        clearMenuCloseTimer(hm);
        closeOtherHeaderMenus(hm);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = () => {
        if (!isDesktop()) return;
        clearMenuCloseTimer(hm);
        const t = window.setTimeout(() => {
          try {
            if (!hm.matches(':hover')) {
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', 'false');
            }
          } catch (e) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
          closeTimers.delete(hm);
        }, CLOSE_DELAY_MS);
        closeTimers.set(hm, t);
      };

      hm.addEventListener('mouseenter', openMenu);
      hm.addEventListener('mouseleave', closeMenu);
    });
  }

  let scrollShadowBound = false;

  /**
   * Entrada tipo “motion” (Framer es React-only): animación CSS al abrir mega/dropdown.
   */
  function initPanelMotion(scope) {
    scope.querySelectorAll('header-menu details').forEach((details) => {
      if (details.dataset.neuroMotionInit === '1') return;
      details.dataset.neuroMotionInit = '1';
      const summary = details.querySelector('summary');
      const panel = summary && summary.nextElementSibling;
      if (!panel || !panel.classList) return;

      details.addEventListener('toggle', () => {
        if (!details.open) {
          panel.classList.remove('neuro-motion-panel-in');
          return;
        }
        if (!isDesktop()) return;
        panel.classList.remove('neuro-motion-panel-in');
        void panel.offsetWidth;
        panel.classList.add('neuro-motion-panel-in');
        const onEnd = (e) => {
          if (e.animationName !== 'neuroPharmaPanelIn') return;
          panel.removeEventListener('animationend', onEnd);
          panel.classList.remove('neuro-motion-panel-in');
        };
        panel.addEventListener('animationend', onEnd);
      });
    });
  }

  function initScrollShadow() {
    const header = document.querySelector('.neurotroopics-header');
    if (!header || scrollShadowBound) return;
    scrollShadowBound = true;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const el = document.querySelector('.neurotroopics-header');
        if (el) el.classList.toggle('neuro-scrolled', window.scrollY > 24);
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function closeAllHeaderMenus() {
    document.querySelectorAll('.neurotroopics-shell header-menu').forEach((hm) => {
      clearMenuCloseTimer(hm);
      const d = hm.querySelector('details');
      const s = d && d.querySelector('summary');
      if (d) d.removeAttribute('open');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!isDesktop()) closeAllHeaderMenus();
    }, 150);
  });

  function onReady() {
    const shell = document.querySelector('.neurotroopics-shell');
    if (!shell) return;
    initHoverMenus(shell);
    initPanelMotion(shell);
    initScrollShadow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (!root || !root.querySelector) return;
    const shell = root.matches('.neurotroopics-shell') ? root : root.querySelector('.neurotroopics-shell');
    if (shell) {
      initHoverMenus(shell);
      initPanelMotion(shell);
    }
    initScrollShadow();
  });
})();
